import { useState } from "react";
import { Star } from "lucide-react";
import api from "@/lib/api";

export default function ReviewPrompt({ problem, onReviewed }) {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [dismissed, setDismissed] = useState(Boolean(problem.review_prompt_dismissed_at));
  const [error, setError] = useState("");
  if (problem.status !== "completed" || problem.has_review || dismissed) return null;

  const dismiss = async () => {
    setDismissed(true);
    await api.post(`/problems/${problem.id}/review-prompt/dismiss`).catch(() => setDismissed(false));
  };
  const submit = async (event) => {
    event.preventDefault();
    if (!rating) return setError("Vælg mellem 1 og 5 stjerner.");
    setBusy(true); setError("");
    try {
      await api.post("/reviews", { problem_id: problem.id, rating, comment });
      onReviewed?.();
    } catch (requestError) {
      setError(requestError.response?.data?.detail || "Anmeldelsen kunne ikke gemmes.");
    } finally { setBusy(false); }
  };

  return <section className="mt-5 rounded-2xl border border-brand-line-strong bg-brand-soft p-5" data-testid="review-prompt">
    <p className="text-xs font-bold uppercase tracking-[.14em] text-brand-fresh">Hvordan gik det?</p>
    <h2 className="mt-2 text-xl font-semibold text-brand-ink">Del din oplevelse med eksperten</h2>
    <p className="mt-1 text-sm text-brand-body">Din anmeldelse hjælper andre med at vælge den rette hjælp.</p>
    {!open ? <div className="mt-4 flex flex-wrap gap-3"><button type="button" className="btn-primary" onClick={() => setOpen(true)}>Skriv en anmeldelse</button><button type="button" className="btn-secondary" onClick={dismiss}>Ikke nu</button></div> : <form onSubmit={submit} className="mt-4">
      <fieldset><legend className="text-sm font-semibold text-brand-ink">Din bedømmelse</legend><div className="mt-2 flex gap-1">{[1,2,3,4,5].map((value) => <button key={value} type="button" onClick={() => setRating(value)} className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-fresh" aria-label={`${value} stjerner`} aria-pressed={rating === value}><Star size={25} className={value <= rating ? "fill-[#D97706] text-[#D97706]" : "text-brand-line"}/></button>)}</div></fieldset>
      <label className="mt-4 block text-sm font-semibold text-brand-ink">Kommentar <span className="font-normal text-brand-muted">(valgfri)</span><textarea value={comment} onChange={(event) => setComment(event.target.value)} rows={3} className="mt-2 w-full rounded-xl border border-brand-line bg-white px-4 py-3 font-normal outline-none focus:border-brand-fresh"/></label>
      {error && <p className="mt-2 text-sm text-[#991B1B]" role="alert">{error}</p>}
      <div className="mt-4 flex flex-wrap gap-3"><button disabled={busy} className="btn-primary">{busy ? "Gemmer…" : "Send anmeldelse"}</button><button type="button" className="btn-secondary" onClick={() => setOpen(false)}>Tilbage</button></div>
    </form>}
  </section>;
}

